import React from "react";
import Icon from "@ant-design/icons";

const TwoPersonFilledSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        fill="none"
        viewBox="0 0 40 40"
    >
        <circle cx="20" cy="20" r="20" fill="#F0F5FA" />
        <path
            fill="#165ABF"
            d="M23.6115 19.6667C25.1238 19.6667 26.4014 18.327 26.4014 16.5937C26.4014 14.9018 25.1169 13.6035 23.6115 13.6035C22.1129 13.6035 20.8216 14.9225 20.8285 16.6075C20.8285 18.327 22.0991 19.6667 23.6115 19.6667ZM15.6285 19.8255C16.9475 19.8255 18.0593 18.6516 18.0593 17.1461C18.0593 15.6683 16.9337 14.5427 15.6285 14.5427C14.3233 14.5427 13.1977 15.689 13.2046 17.1599C13.2046 18.6516 14.3164 19.8255 15.6285 19.8255ZM11.8235 26.0959H17.0027C16.2638 25.0393 17.058 22.9538 18.6187 21.7246C17.859 21.2343 16.8715 20.8752 15.6285 20.8752C12.5416 20.8752 10.5459 23.1472 10.5459 25.0186C10.5459 25.7023 10.8912 26.0959 11.8235 26.0959ZM19.3092 26.089H27.9137C29.0532 26.089 29.4468 25.7437 29.4468 25.1084C29.4468 23.3336 27.1886 20.889 23.6115 20.889C20.0274 20.889 17.7762 23.3336 17.7762 25.1084C17.7762 25.7437 18.1698 26.089 19.3092 26.089Z"
        />
    </svg>
);

const TwoPersonFilledIcon = (props) => (
    <Icon component={TwoPersonFilledSvg} {...props} />
);

export { TwoPersonFilledIcon };